import {
  createPaginatedList,
  paginationGroup
} from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import { ID } from "APP_ROOT/constants";
import { config } from "MODULES/parts/pagination";
import { combineReducers } from "redux";
import { composables } from "@orange-marmalade/paginate-this";
import * as actions from "./actions";

export const purchaseOrdersPagination = createPaginatedList({
  listId: "purchaseOrders",
  fetch: api.purchaseOrders.search,
  forceDebounce: true,
  stateLocator: state => state.purchaseOrdersPagination.main
});

export const expireReceivedCores = composables({
  listId: "purchaseOrders/receivedCores"
}).expire;

export const purchaseOrderLineItems = createPaginatedList({
  listId: "purchaseOrderLineItems",
  fetch: actions.searchLineItems,
  initialSettings: {
    pageSize: 5
  }
});

const [receivingRecords, receivedCores] = paginationGroup(
  {
    groupName: "purchaseOrders",
    getId: state => state.purchaseOrderDetail.getIn(["purchaseOrder", ID]),
    locate: ({ key }) => state => state.purchaseOrdersPagination[key]
  },
  config("receivingRecords", false, api.purchaseOrders.receivingRecords.search),
  config("receivedCores", false, api.purchaseOrders.receivedCores.search)
);

export default combineReducers({
  main: purchaseOrdersPagination.paginator,
  receivingRecords,
  receivedCores
});



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/pagination.js